export default {
  introduction: {
    path: '/',
  },
  qualificationScreen: {
    path: '/qualification',
    props: {
      form: 'other-qualification',
      formScreen: 1,
    },
  },
  categoriesScreen: {
    path: '/categories',
    props: {
      form: 'cpcs-categories',
      formScreen: 2,
    },
  },
  home: {
    path: '/applicant-details',
    props: {
      form: 'applicant-details',
      formScreen: 3,
    },
  },
  addressScreen: {
    path: '/address',
    props: {
      form: 'mailing-address',
      formScreen: 4,
    },
  },
  declarationScreen: {
    path: '/declaration',
    props: {
      form: 'declaration',
      formScreen: 5,
    },
  },
  summaryScreen: {
    path: '/summary',
    props: {
      formScreen: 6,
    },
  },
  fileUploadScreen: {
    path: '/evidence',
    props: {
      form: 'file-upload',
      formScreen: 7,
    },
  },
  successScreen: {
    path: '/success',
    props: {
      formScreen: 8,
    },
  },
};
